import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/login',
      name: 'login',
      component: () => import(/* webpackChunkName: "login" */ '@/views/Login.vue'),
      needAuth: false
    },
    {
      path: '/',
      name: 'requests',
      component: () => import(/* webpackChunkName: "requests" */ '@/views/Requests.vue'),
      needAuth: true
    },
    {
      path: '/reports',
      name: 'reports',
      component: () => import(/* webpackChunkName: "reports" */ '@/views/Reports.vue'),
      needAuth: true
    },
    {
      path: '/complexes',
      name: 'ComplexesReport',
      component: () => import(/* webpackChunkName: "complexes" */ '@/views/ComplexesReport.vue'),
      needAuth: true
    },
    {
      path: '/printhtml',
      name: 'printHtml',
      component: () => import(/* webpackChunkName: "printhtml" */ '@/views/PrintHtml.vue'),
      needAuth: true
    },
  ]
})
